import { MapPin, Globe } from "lucide-react";
import { waLink } from "@/lib/constants";

const CITIES = [
  "Ribeirão Preto",
  "Sertãozinho",
  "Cravinhos",
  "Jardinópolis",
  "Serrana",
  "Bonfim Paulista",
  "Dumont",
  "Pradópolis",
  "Brodowski",
  "Batatais",
  "Barrinha",
  "Luís Antônio",
  "Guatapará",
  "Monte Alto",
  "Pontal",
  "Santa Rita do Passa Quatro",
  "São Simão",
  "Pitangueiras",
];

export const ServiceArea = () => {
  return (
    <section
      id="area"
      data-testid="area-section"
      className="section-pad relative overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-40"></div>

      <div className="container-custom relative">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div>
            <span className="overline">Cobertura Geográfica</span>
            <h2 className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight">
              Atendemos{" "}
              <span className="text-[#d90429]">Ribeirão Preto</span>{" "}
              e toda a região
            </h2>
            <p className="mt-5 text-gray-300 text-lg leading-relaxed">
              Chegamos com agilidade em todos os bairros de Ribeirão Preto e
              cidades vizinhas. Também realizamos{" "}
              <strong className="text-white">
                viagens e transportes para qualquer cidade ou estado do Brasil
              </strong>
              .
            </p>

            <div className="mt-8 flex items-center gap-3 text-[#d90429] font-display uppercase tracking-wider">
              <MapPin className="w-5 h-5" />
              <span className="text-white">Base: Reserva Imperial</span>
            </div>

            <div className="mt-6 flex flex-wrap gap-2">
              {CITIES.map((c, i) => (
                <span
                  key={i}
                  data-testid={`city-${i}`}
                  className="px-4 py-2 bg-[#141414] border border-[#2d3748] text-white/85 text-xs font-display uppercase tracking-wider hover:border-[#d90429] hover:text-[#d90429] transition-colors"
                >
                  {c}
                </span>
              ))}
            </div>

            <div className="mt-8 card-dark p-6 flex items-start gap-4">
              <Globe className="w-8 h-8 text-[#d90429] shrink-0 mt-1" />
              <div>
                <h3 className="font-display uppercase font-bold text-white text-lg mb-1">
                  Viagens Nacionais
                </h3>
                <p className="text-gray-400 text-sm">
                  Transportamos seu veículo para qualquer cidade ou estado do
                  Brasil com segurança total.
                </p>
              </div>
            </div>

            <a
              href={waLink("Olá! Gostaria de um orçamento para viagem/transporte.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="area-cta"
              className="btn-wa mt-8"
            >
              <i className="fa-brands fa-whatsapp text-xl" aria-hidden></i>
              Solicitar Orçamento
            </a>
          </div>

          <div className="relative">
            <div className="absolute -inset-3 border-2 border-[#d90429]/30 -z-10"></div>
            <div className="relative aspect-[4/3] w-full overflow-hidden bg-[#141414] border border-[#2d3748]">
              <iframe
                title="Localização Auto Socorro Ventania — Ribeirão Preto"
                src="https://www.google.com/maps?q=Condom%C3%ADnio%20Reserva%20Imperial%2C%20Ribeir%C3%A3o%20Preto%20SP&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, filter: "grayscale(30%) invert(92%) hue-rotate(180deg)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="google-map-iframe"
              ></iframe>
            </div>
            <div className="mt-4 text-sm text-gray-400">
              <strong className="text-white">Endereço:</strong> Rua Delfon e
              Luiza Bressan, nº 440 — Reserva Imperial, Ribeirão Preto/SP
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
